import { useEffect, useRef } from 'preact/hooks';

import { useLiveStreamPlayerStateContext } from './contexts';

const LiveStreamPlayerVisibilityHandler = () => {
  const { isPlaying, requestChangePlayingState } = useLiveStreamPlayerStateContext();
  const autoPausedRef = useRef(false);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden) {
        // Pause if currently playing
        if (isPlaying) {
          requestChangePlayingState(false);
          autoPausedRef.current = true;
        }
        return;
      }

      // Resume if we auto-paused
      if (autoPausedRef.current) {
        requestChangePlayingState(true);
        autoPausedRef.current = false;
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [isPlaying, requestChangePlayingState]);

  return null;
};

export default LiveStreamPlayerVisibilityHandler;
